// extracted by mini-css-extract-plugin
export default {"section":"lo9OiZRt","title":"aogtgsZf","gridContainer":"bm6dVqMG","logo":"FbvUdgrK","placeholderLogo":"_rLUmPoV","agentName":"IY2136Xo"};